import config from 'client/shared/config';

import {
	observable,
	action,
	computed,
	runInAction,
	reaction
} from 'mobx';

import BaseStore from './base-store';
import apiStore from './api-store';

class EventStore extends BaseStore {
	@action
	async postEvent (payload) {
		this.isLoading = true;

		try {

            return await apiStore.save({
                silent: true,
                route: config.getRoute('mzdEvent'),
                payload: {
                    ...payload,
                    memberID: apiStore.userID
                }
            });
		} catch (err) {

            console.log('[ERROR EventStore.fetchEvents]', err);
		} finally {

            this.isLoading = false;
		}
	}

    @action
    async favoriteSong (songID) {
        this.isLoading = true;

        try {

            const route = config.getRoute('mzdEvent');
            const { userID } = apiStore;
            const payload = { 
                memberID: userID,
                itemID: songID,
                itemType: 'song',
                eventPayload: {
                    action: 'favorite',
                    clientTime: new Date().toISOString()
                }
            };

            return await apiStore.save({ route, payload, silent: true });
        } catch (err) {

            console.log('[ERROR EventStore.favoriteSong]', err);    
        } finally {

            this.isLoading = false; 
        }
    }

    @action
    async listenToSong (songID) {
        this.isLoading = true;

        try {

            const route = config.getRoute('mzdEvent');
            const { userID } = apiStore;
            const payload = { 
                memberID: userID,
                itemID: songID,
                itemType: 'song',
                eventPayload: {
                    action: 'listen',
                    clientTime: new Date().toISOString()
                }
            };

            return await apiStore.save({ route, payload, silent: true });
        } catch (err) {

            console.log('[ERROR EventStore.favoriteSong]', err);    
        } finally {

            this.isLoading = false; 
        }
    }

    @action
    async unfavoriteSong (id) {
        this.isLoading = true;

        try {

            const route = `${config.getRoute('mzdEvent')}/${id}`;
            console.log('[EventStore.unfavoriteSong]', route);
            // await apiStore.delete({ route });
        } catch (err) {

            console.log('[ERROR EventStore.unfavoriteSong]', err);
        } finally {

            this.isLoading = false; 
        }
    }       
}

const eventStore = new EventStore();
export default eventStore; 